import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import AdminLayout from "../../../components/admin/common/AdminLayout";
import EditUserForm from "../../../components/admin/users/EditUserForm";
import { clearUser, getUser } from "../../../redux/slice/usersSlice";

const EditUser = () => {
  const id = useParams().id;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUser(id));
    return () => {
      dispatch(clearUser());
    };
  }, [dispatch, id]);

  return (
    <>
      <AdminLayout>
        <EditUserForm />
      </AdminLayout>
    </>
  );
};

export default EditUser;
